import { useDropdownMenu } from '@lwt-helix/useDropdownMenu';
import React, { useRef } from 'react';
import DropdownMenu from './DropdownMenu.js';
import DropdownMenuItem from './DropdownMenuItem.js';
import { NavbarHelixIcon } from './NavbarHelixIcon.js';
import { clickDropdownItem } from './NavbarHelpers.js';

/* eslint-disable @typescript-eslint/no-explicit-any */
const NavbarDropdownNavItem = ({ navItem, linkWrapper, location }) => {
    const { isOpen, getToggleButtonProps, getMenuProps, highlightedIndex, getItemProps, setReferenceElement, setPopperElement, attributes, styles } = useDropdownMenu({
        placement: 'bottom-end',
        items: navItem.menuItems,
        resetSelectedItemOnClose: true,
        itemToString: (item) => (item.label ? item.label : ''),
        offset: [0, 8]
    });
    const menuRef = useRef(null);
    const isActive = () => {
        if (navItem.menuItems) {
            return (navItem.menuItems.filter((item) => item.url === location.pathname).length > 0 ||
                navItem.menuItems.filter((item) => item.active).length > 0 ||
                navItem.menuItems.filter((item) => item.activePathname === location.pathname).length > 0 ||
                navItem.active);
        }
        return navItem.url === location.pathname || navItem.active;
    };
    const handleKeyDown = (e) => {
        clickDropdownItem(e, menuRef);
    };
    return (React.createElement("span", { className: 'helix-unified-nav__navigation-item-dropdown-wrapper' },
        React.createElement("button", Object.assign({}, getToggleButtonProps({
            ref: setReferenceElement
        }), { disabled: navItem.disabled, className: isActive()
                ? 'helix-unified-nav__navigation-item helix-unified-nav__navigation-item-dropdown active'
                : 'helix-unified-nav__navigation-item helix-unified-nav__navigation-item-dropdown' }),
            navItem.label,
            " ",
            React.createElement(NavbarHelixIcon, { iconName: 'dropdown_open' })),
        React.createElement(DropdownMenu, Object.assign({ maxWidth: '300px', ref: setPopperElement, isOpen: isOpen, style: styles.popper, className: 'helix-unified-nav__notification-dropdown-menu' }, attributes.popper),
            React.createElement("ul", Object.assign({}, getMenuProps({
                onKeyDown: (e) => handleKeyDown(e),
                ref: (ref) => (menuRef.current = ref)
            })), isOpen && (React.createElement(React.Fragment, null, navItem.menuItems &&
                navItem.menuItems.map((menuItem, index) => (React.createElement(DropdownMenuItem, { className: `${menuItem.url === location.pathname ||
                        (menuItem.activePathname &&
                            menuItem.activePathname === location.pathname) ||
                        menuItem.active ||
                        menuItem.activePathname === location.pathname
                        ? 'selected-item'
                        : ''}`, menuItem: menuItem, highlightedIndex: highlightedIndex, index: index, linkWrapper: linkWrapper, getItemProps: getItemProps, key: `${menuItem.label}${index}` })))))))));
};

export { NavbarDropdownNavItem as default };
//# sourceMappingURL=NavbarDropdownNavItem.js.map
